<template>
  <component
    class="text-navy font-sans"
    :is="headingTag.toLowerCase()"
    :class="[style.toLowerCase(), bottomSpacing ? 'heading-spacing' : '']">
    <slot></slot>
  </component>
</template>

<script>
import { useIsHeaderTag } from "../../compostables/useValidators";

export default {
  props: {
    headingTag: {
      type: String,
      required: false,
      default: "h2",
      validator(value) {
        return useIsHeaderTag(value);
      },
    },
    style: {
      type: String,
      required: false,
      default: "h2",
      validator(value) {
        return useIsHeaderTag(value);
      },
    },
    bottomSpacing: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  setup() {},
};
</script>
